var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveForLaterMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19755 2.74706L19.1952 2.74791C20.1868 2.74806 20.9905 3.55182 20.9907 4.54336L20.9873 21.2681C20.9878 21.6315 20.7691 21.9594 20.4334 22.0986C20.0977 22.2378 19.7111 22.161 19.4543 21.9038L12.696 16.7791L5.93683 21.903C5.67999 22.1594 5.29406 22.236 4.9588 22.097C4.62353 21.9581 4.40487 21.631 4.40464 21.2681L4.40464 4.53998C4.40619 3.55042 5.208 2.74861 6.19755 2.74706Z",
    stroke: "#F2F4F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveForLaterMobile);
export default __webpack_public_path__ + "static/media/save-for-later-mobile.e6fdbc5fb2f074eeae5b9ec20de937b7.svg";
export { ForwardRef as ReactComponent };